class EproViewerController {
	constructor(
		$log,
		$scope,
		$state,
		$stateParams,
		$filter,
		$sce,
		$document,
		$timeout,
		appSession,
		appConfig,
		appI18n,
		$q,
		$window,
		eproService,
		spirometryService,
		loadingIndicatorService
	) {
		'ngInject';
		this.$log = $log;
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$filter = $filter;
		this.$sce = $sce;
		this.$document = $document;
		this.$timeout = $timeout;
		this.appSession = appSession;
		this.appConfig = appConfig;
		this.appI18n = appI18n;
		this.$q = $q;
		this.$window = $window;
		this.eproService = eproService;
		this.spirometryService = spirometryService;
		this.loadingIndicatorService = loadingIndicatorService;
	}

	$onInit() {
		this.$log = this.$log.getInstance('EproViewerController');
		this.$log.debug('loaded');

		this.siteId = this.$stateParams.site;
		this.subjectId = this.$stateParams.subject;
		this.eventId = this.$stateParams.event;
		this.testDataTypeId = this.$stateParams.testDataType;
		this.visitName = this.$stateParams.visit;
        this.options = {
            formActivityData: [],
			dailysessionsData: [],
			notificationsData: [],
			sessionNotificationCountData: []
        };
		this.sessionContext = [];
        this.selectedDailySession = null;
		this.selectedTimepoint = null;
		this.selectedTimepointTab = null; 
		this.selectedPatientVisitInfoId = null;
		this.selectedSession = null;
		this.sessionDisplayName = null;
		this.isEproDataType = false,
		this.isHpftDataType = false,
		this.isQuestionResponseLoading = false;
		this.isNotificationsResponseLoading = false;
		this.isSessionLevelNotificationsResponseLoading = false;
		this.dateFormat = 'dateFormat';
		
		// Initialize tab-related properties
		this.tabs = [];
		this.activeTimepointTab = null;
		this.timepointData = {};
		
		this.loadingIndicatorService.show();
		this.getISpiroEproDailySessions(this.options).then((response) => {
			this.options.dailysessionsData = response.data;
			if (this.options.dailysessionsData.length > 0) {
				this.selectedDailySession = this.options.dailysessionsData[0];
				this.selectDaily(this.selectedDailySession);
			}
		}).finally(() => {
			this.loadingIndicatorService.hide();
		});
	}

	async selectDaily(daily) {
        this.selectedDailySession = daily;
		this.selectedTimepoint = null;
		this.selectedSession = false;
		await this.getIspiroEproSessionLevelNotificationsCount(daily.sessionDate).then((response) => {
			this.options.sessionNotificationCountData = this.buildSessionNotificationCountArray(response.data);
		});
		await this.getIspiroEproFormActivity(daily.sessionDate).then((response) => {
			this.options.formActivityData = this.processFormActivityData(response.data);
			// Initialize all tabs after form activity data is loaded
			if (this.options.formActivityData.length > 0 && this.options.formActivityData[0].entries.length > 0) {
				this.expandSession(this.options.formActivityData[0]);
			}
		});
    }

	// New method to initialize all tabs at loading
	initializeAllTabs(patientVisitInfoId) {
		if (this.options && this.options.formActivityData) {
			const availableTabs = [];
			
			this.options.formActivityData.forEach(activity => {
				if (activity.entries && activity.entries.length > 0 && activity.patientVisitInfoId === patientVisitInfoId) {
					activity.entries.forEach(entry => {
						if (entry.timepointName && entry.eventId) {
							availableTabs.push({
								displayName: entry.timepointName,
								eventId: entry.eventId,
								testDataTypeId: entry.testDataTypeId,
								globalFormDetailId: entry.globalFormDetailId,
								transmittalNumber: entry.transmittalNumber,
								notificationCount: entry.notificationCount,
								ref: `timepoint-${entry.eventId}`, // Add ref for navigation
								isActive: false,
								displayOrder: entry.displayOrder
							});
						}
					});
				}
			});
			
			// Sort availableTabs by displayOrder before assigning to this.tabs
			availableTabs.sort((a, b) => a.displayOrder - b.displayOrder);
			this.tabs = availableTabs;
			
			// Set first timepoint as active if available
			if (this.tabs.length > 0) {
				this.tabs[0].isActive = true;
				this.activeTimepointTab = this.tabs[0].eventId;
				this.selectedTimepointTab = this.tabs[0].displayName;
				this.eventId = this.tabs[0].eventId;
				
				// Load data for the first tab
				this.loadTimepointData(this.tabs[0]);
			}
		}
	}

	expandSession(entry) {
		this.arrNotficationsSessionLevel = [];
		entry.uncollapsed = !entry.uncollapsed;
		this.renderSessionContext(entry);
		this.sessionDisplayName = entry.visitName;
		this.selectedTimepoint = entry.visitName;
		this.selectedPatientVisitInfoId = entry.patientVisitInfoId;
		this.selectedSession = true;
		this.isSessionLevelNotificationsResponseLoading = true;
		this.getIspiroEproSessionLevelNotificationsResponse(entry.patientVisitInfoId)
				.then((response) => {
				this.options.notificationsData = response.data;
				if (response.data !== null && this.options.notificationsData.length > 0) {
					this.arrNotficationsSessionLevel = this.options.notificationsData[0].notificationsXml;
				} else {
					this.arrNotficationsSessionLevel = [];
				}
			})
			.finally(() => {
				this.isSessionLevelNotificationsResponseLoading = false;
			});
		this.initializeAllTabs(entry.patientVisitInfoId);
		}

	

	selectTimepoint(entry) {
		if (!entry) {
			return;
		}
		
		// Set as active tab (timepoint should already be in the tabs from initialization)
		this.activeTimepointTab = entry.eventId;
		this.selectedTimepoint = entry.timepointName;
		this.eventId = entry.eventId;
		
		// Load data for the selected timepoint
		this.loadTimepointData(entry);
	}

	// Set active tab
	setActiveTimepointTab(tab) {
		// Deactivate all tabs first
		this.tabs.forEach(t => t.isActive = false);
		
		// Set the clicked tab as active
		tab.isActive = true;
		this.activeTimepointTab = tab.eventId;
		this.selectedTimepoint = tab.displayName;
		this.eventId = tab.eventId;
		
		// Load data for the selected timepoint
		this.loadTimepointData(tab);
	}

	// Close a tab
	closeTimepointTab(eventId, $event) {
		if ($event) {
			$event.stopPropagation();
		}
		
		const index = this.tabs.findIndex(tab => tab.eventId === eventId);
		if (index > -1) {
			this.tabs.splice(index, 1);
			
			// If closed tab was active, set another tab as active
			if (this.activeTimepointTab === eventId) {
				if (this.tabs.length > 0) {
					this.setActiveTimepointTab(this.tabs[0]);
				} else {
					this.activeTimepointTab = null;
					this.selectedTimepoint = null;
					this.eventId = null;
				}
			}
		}
	}

	// Load data for specific timepoint
	loadTimepointData(entry) {
		this.arrNotfications = [];
		this.isHpftDataType = false;
		this.selectedTimepoint = entry.timepointName;
		this.isQuestionResponseLoading = true;
		this.isNotificationsResponseLoading = true;
		this.eventId = entry.eventId;
		if (entry.testDataTypeId) {
			if (+entry.testDataTypeId === this.appConfig.testDataType.homeForcedSpirometry) {
				this.isHpftDataType = true;
				this.isEproDataType = false;
				this.spiroViewerUrl = this.setSpiroViewerUrl();
			} else if (+entry.testDataTypeId === this.appConfig.testDataType.epro) {
				this.isEproDataType = true;
				this.isHpftDataType = false;
			}
		}
		
		if (entry.globalFormDetailId) {
			if (!this.timepointData) {
				this.timepointData = {};
			}
			if (!this.timepointData[entry.eventId]) {
				this.timepointData[entry.eventId] = {};
			}

			this.getISprioEproFormJson(entry.transmittalNumber)
				.then((formJsonResponse) => {
					this.timepointData[entry.eventId].formJson = this.parseEproFormJson(formJsonResponse.data);
				})
				.finally(() => {
					this.isQuestionResponseLoading = false;
					// The <form-engine-form-viewer> element only renders once this loading
					// flag is false, so (re)apply any form JSON we already have for it.
					this.applyFormJsonToWidget(entry.eventId);
				});
		}
		
		if (entry.notificationCount > 0) {
			this.getIsprioEproNotificationsResponse()
				.then((response) => {
				this.options.notificationsData = response.data;
				if (response.data !== null && this.options.notificationsData.length > 0) {
						// Store notifications specific to this timepoint
						if (!this.timepointData) {
							this.timepointData = {};
						}
						if (!this.timepointData[entry.eventId]) {
							this.timepointData[entry.eventId] = {};
						}
						this.timepointData[entry.eventId].notifications =
																	this.options.notificationsData[0].notificationsXml;
					this.arrNotfications = this.options.notificationsData[0].notificationsXml;
				} else {
					this.arrNotfications = [];
				}
			})
			.finally(() => {
				this.isNotificationsResponseLoading = false;
			});
		} else {
			this.isNotificationsResponseLoading = false;
		}
	}

	// Get spirometry viewer URL for specific timepoint
	getSpiroViewerUrlForTimepoint(eventId) {
		// For spirometry data, return URL if this is the active timepoint and it's spirometry data
		if (this.activeTimepointTab === eventId && this.isHpftDataType) {
			return this.spiroViewerUrl;
		}
		return '';
	}

	renderSessionContext(session) {
		this.sessionContext = [
			{ label: 'Phase Name', value: session.periodName },
			{ label: 'Session Name', value: session.visitName },
			{ label: 'Session Status', value: session.dataStatus },
			{ label: 'Session Start Time', value: session.patientVisitInfoStartTimestampForUI },
			{ label: 'Session End Time', value: session.patientVisitInfoEndTimestampForUI }
		];
	}
	getISpiroEproDailySessions(options) {
		return this.eproService.getISpiroEproDailySessions(this.siteId, this.subjectId, options);
	}
	getIspiroEproFormActivity(sessionDate) {
		return this.eproService.getISpiroEproFormActivity(this.subjectId, sessionDate);
	}
	getISprioEproFormJson(transmittalNumber) {
		return this.eproService.getISpiroEproFormJson(this.subjectId, transmittalNumber);
	}

	// Extracts and JSON.parses the three CLOB columns returned by the form-json API
	// (URF_FORM_DATA_CONTENT / URF_FORM_LAYOUT_CONTENT / FORM_RESPONSE_LAYOUT).
	parseEproFormJson(responseData) {
		if (!Array.isArray(responseData) || responseData.length === 0) {
			return null;
		}
		var item = responseData[0];
		return {
			dataArtifact: this.safeJsonParse(item.formDataContent),
			layoutArtifact: this.safeJsonParse(item.formLayoutContent),
			initialValues: this.safeJsonParse(item.formResponseLayout)
		};
	}

	safeJsonParse(value) {
		if (value === null || value === undefined || value === '') {
			return null;
		}
		if (typeof value !== 'string') {
			return value;
		}
		try {
			return JSON.parse(value);
		} catch (e) {
			this.$log.warn('Failed to parse epro form JSON', e);
			return null;
		}
	}

	// True when the backend returned form data for this timepoint. Used by the
	// template to avoid rendering <form-engine-form-viewer> when there is no response.
	hasFormData(eventId) {
		var formJson = (this.timepointData && this.timepointData[eventId])
			? this.timepointData[eventId].formJson : null;
		return !!formJson;
	}

	// Assigns the parsed form JSON as JS properties on the <form-engine-form-viewer>
	applyFormJsonToWidget(eventId) {
		var formJson = (this.timepointData && this.timepointData[eventId])
			? this.timepointData[eventId].formJson : null;
		if (!this.hasFormData(eventId)) {
			return;
		}
		// Defer until AngularJS has rendered the element (it appears only after
		// isQuestionResponseLoading becomes false).
		this.$timeout(() => {
			var el = this.$document[0].getElementById('form-engine-' + eventId);
			if (!el) {
				return;
			}
			el.dataArtifact = formJson.dataArtifact || null;
			el.layoutArtifact = formJson.layoutArtifact || null;
			el.initialValues = formJson.initialValues || null;
		});
	}
	getIsprioEproNotificationsResponse() {
		return this.eproService.getIspiroEproNotifications(this.subjectId, this.eventId);
	}
	getIspiroEproSessionLevelNotificationsResponse(patientVisitInfoId) {
		return this.eproService.getIspiroEproSessionLevelNotifications(this.subjectId, patientVisitInfoId);
	}
	getIspiroEproSessionLevelNotificationsCount(sessionDate) {
		return this.eproService.getIspiroEproSessionLevelNotificationsCount(this.subjectId, sessionDate);
	}

	processFormActivityData(data) {
        const processedData = [];
        const groupedData = {};

        // Build a quick lookup map from sessionNotificationCountData
        const notificationCountMap = {};
        (this.options.sessionNotificationCountData || []).forEach(r => {
            // normalize key as string
            notificationCountMap[String(r.patientVisitInfoId)] = r.notificationCount;
        });

        data.forEach(item => {
            const key = String(item.patientVisitInfoId);
            if (!groupedData[key]) {
                groupedData[key] = {
                    visitName: item.visitName,
                    visitSequence: item.visitSequence,
                    patientVisitInfoStartTimestamp: item.patientVisitInfoStartTimestamp,
                    patientVisitInfoId: item.patientVisitInfoId,
                    dataStatus: item.dataStatus,
                    patientVisitInfoEndTimestampForUI: item.patientVisitInfoEndTimestamp_ForUI,
                    patientVisitInfoStartTimestampForUI: item.patientVisitInfoStartTimestamp_ForUI,
                    periodName: item.periodName,
                    notificationCount: notificationCountMap[key] ?? 0,
                    entries: []
                };
            }
            groupedData[key].entries.push(item);
        });

        const sortedVisits = Object.keys(groupedData).sort((a, b) => {
            const visitA = groupedData[a];
            const visitB = groupedData[b];
            if (visitA.visitSequence !== visitB.visitSequence) {
                return visitA.visitSequence - visitB.visitSequence;
            }
            return new Date(visitA.patientVisitInfoStartTimestamp) - new Date(visitB.patientVisitInfoStartTimestamp);
        });

        sortedVisits.forEach(patientVisitInfoId => {
            const visit = groupedData[patientVisitInfoId];
            visit.entries.sort((a, b) => {
                if (a.timepointSequence !== b.timepointSequence) {
                    return a.timepointSequence - b.timepointSequence;
                }
                return a.transmittalNumber - b.transmittalNumber;
            });
            const isExpandable = visit.entries.every(entry => entry.timepointName !== null);

			const hasMissedSessions = this.checkHasMissedSessionsInFormActivity(visit);

            processedData.push({
                patientVisitInfoId: visit.patientVisitInfoId,
                visitName: visit.visitName,
                entries: visit.entries,
                isExpandable,
                notificationCount: visit.notificationCount, // from sessionNotificationCountData
                dataStatus: visit.dataStatus,
                patientVisitInfoEndTimestampForUI: visit.patientVisitInfoEndTimestampForUI,
                patientVisitInfoStartTimestampForUI: visit.patientVisitInfoStartTimestampForUI,
                periodName: visit.periodName,
				missedSessions: hasMissedSessions
            });
        });
        return processedData;
    }
	
	checkHasMissedSessionsInFormActivity(visit) {
			if (!visit.entries || visit.entries.length === 0) {
			return false;
		}
		
		return visit.entries.some(entry => {
			return entry.dataStatus === 'Missed';
		});
	}

	setSpiroViewerUrl() {
		return this.spirometryService.getSpiroViewerUrl(this.siteId, this.subjectId, this.eventId,
				 this.appConfig.constants.spiroViewerVersion.spiro2019, null);
		
	}

	isOptionSelected(option, response) {
		if (!response.answer || response.answer.length === 0) {
			return false;
		}
		return response.answer.some((answer) => {
			return answer.id === option.id && answer.value === option.value;
		});
	}

	buildSessionNotificationCountArray(data) {
        if (!data) {return [];}
        if (Array.isArray(data)) {
            return data.map(d => ({
                patientVisitInfoId: Number(d.patientVisitInfoId),
                notificationCount: Number(d.notificationCount) || 0
            }));
        }
        // single object fallback
        return [{
            patientVisitInfoId: Number(data.patientVisitInfoId),
            notificationCount: Number(data.notificationCount) || 0
        }];
    }
}

export default EproViewerController;
